<nav class="menu" [class.menu--compressa]="navigazione.compressa()" aria-label="Menu principale">
  <div class="menu__testa">
    <a class="menu__logo" href="/" aria-label="InfoOggi, vai alla dashboard">
      <img src="/public/images/logo.png" alt="InfoOggi" />
    </a>
    <button
      type="button"
      class="menu__comprimi"
      mat-icon-button
      [attr.aria-label]="navigazione.compressa() ? 'Allarga il menu' : 'Restringi il menu'"
      [matTooltip]="navigazione.compressa() ? 'Allarga il menu' : 'Restringi il menu'"
      matTooltipPosition="right"
      (click)="navigazione.alternaCompressione()"
    >
      <mat-icon>{{ navigazione.compressa() ? 'chevron_right' : 'chevron_left' }}</mat-icon>
    </button>
    <button
      type="button"
      class="menu__chiudi"
      mat-icon-button
      aria-label="Chiudi il menu"
      (click)="navigazione.chiudiMobile()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <ul class="menu__voci">
    <li>
      <button
        type="button"
        class="menu__voce"
        [class.menu__voce--attiva]="eDashboard()"
        [matTooltip]="navigazione.compressa() ? 'Dashboard' : ''"
        matTooltipPosition="right"
        (click)="vaiA('/')"
      >
        <mat-icon class="menu__icona">dashboard</mat-icon>
        <span class="menu__etichetta">Dashboard</span>
      </button>
    </li>

    @for (modulo of authService.modules(); track modulo.id) {
      <li class="menu__gruppo" [class.menu__gruppo--aperto]="eGruppoAperto(modulo)">
        <button
          type="button"
          class="menu__voce"
          [class.menu__voce--in-uso]="contienePaginaCorrente(modulo)"
          [attr.aria-expanded]="eGruppoAperto(modulo)"
          [matTooltip]="navigazione.compressa() ? modulo.title : ''"
          matTooltipPosition="right"
          (click)="alternaGruppo(modulo)"
        >
          <mat-icon class="menu__icona">{{ modulo.icon }}</mat-icon>
          <span class="menu__etichetta">{{ modulo.title }}</span>
          <mat-icon class="menu__freccia">expand_more</mat-icon>
        </button>

        <!--
          Un solo figlio nella griglia: l'animazione con grid-template-rows
          funziona sulla prima riga, e con un elenco di voci nasconderebbe solo
          la prima lasciando visibili tutte le altre.
        -->
        <div class="menu__figli">
          <ul class="menu__figli-elenco">
            @for (voce of modulo.navigations; track voce.url) {
              <li>
                <button
                  type="button"
                  class="menu__voce menu__voce--figlia"
                  [class.menu__voce--attiva]="ePaginaCorrente(voce)"
                  [matTooltip]="navigazione.compressa() ? voce.title : ''"
                  matTooltipPosition="right"
                  (click)="vaiA(voce.url)"
                >
                  <mat-icon class="menu__icona">{{ voce.icon }}</mat-icon>
                  <span class="menu__etichetta">{{ voce.title }}</span>
                </button>
              </li>
            }
          </ul>
        </div>
      </li>
    }
  </ul>
</nav>
